<template>
  <div class="container">
    <div class="head">
        <div class="title">
          <div class="text">诚信评价基础工作考评</div>
          <div class="branch">-0.3</div>
        </div>
        <div class="tip">
          <div class="con">大理州-大理市</div>
          <div class="con">一类地区</div>
        </div>
        <div class="date">2019-11-01 12:31:22</div>
      </div>
    <div class="pg-pd12">
      <div>
           <causeDeduction  :causeContent="causeContent" />
      </div>
      <!--文件-->
      <template v-if="subType!='A2'">
        <fileCom :fileList="fileList" ></fileCom>
      </template>
      <!-- 企业信息 -->
      <!-- <template v-if="subType=='A3'||subType=='A4'"> -->
        <companyInfo :detailList="infoList" :title="infoTitle"/>
      <!-- </template> -->
      <!-- <template v-if="subType=='A2'"> -->
        <div class="main">
          <div class="title">诚信评级完成率</div>
          <div class="content">
            <div style=" height:250px;">
              <pieCharts :pieData="pieList"></pieCharts>
            </div>
            <div class="pro-mr">
              <RankChartsRate :rankList="rankList" ></RankChartsRate>
            </div>
            <div class="ts-list" @click="navTo()">
              <span> 查看详情评分情况</span>
            </div>
          </div>
        </div>
      <!-- </template> -->
   </div>
  </div>
</template>
<script>
    // import Vue from 'vue';
    import causeDeduction from './components/causeDeduction';// 扣分原因
    import companyInfo from './components/causeDetail';// 企业详情
    import pieCharts from '../../components/PieCharts';// 环形进度
    import RankChartsRate from './components/RankChartsRate';// 进度
    import fileCom from './components/file';
    import api from '../../service/modules/appraise';

    // Vue.use(Picker);
    export default {
        components: {
            causeDeduction, fileCom, companyInfo, pieCharts, RankChartsRate
        },

        data () {
            return {
                subType: 'A1',
                rankList: [
                    { 'id': 1, 'city': '餐饮', 'mark': '93.23', 'change': 1, 'changeRank': 2 },
                    { 'id': 2, 'city': '住宿', 'mark': '80.00', 'change': 2, 'changeRank': 2 },
                    { 'id': 3, 'city': '旅行社', 'mark': '72.30', 'change': 1, 'changeRank': 2 },
                    { 'id': 4, 'city': '租赁车', 'mark': '60.00', 'change': 2, 'changeRank': 2 },
                    { 'id': 5, 'city': '旅行汽车', 'mark': '50.00', 'change': 0, 'changeRank': 2 }
                ],
                // 饼图
                pieList: [
                    { 'value': 90, 'name': '完成量' },
                    { 'value': 10, 'name': '总数量' }
                ],
                causeContent: '接到游客投诉未在5分钟内响应',
                fileList: [
                    {
                        title: '诚信评级方案',
                        type: 'pdf',
                        name: '大理州大理石涉旅企业诚信评价工作手册大理州大理石涉旅企业诚信评价工作手册'
                    },
                    {
                        title: '委托合同',
                        type: 'pdf',
                        name: '大理州大理石涉旅企业诚信评价工作手册'
                    },
                    {
                        title: '投入专项经费依据',
                        type: 'pdf',
                        name: '大理州大理石涉旅企业诚信评价工作手册'
                    },
                    {
                        title: '政务评级-规范指数评价表',
                        type: 'doc',
                        name: '大理州大理石涉旅企业诚信评价工作手册'
                    }
                ],
                infoTitle: '企业信息',
                infoList: [{
                               name: '企业名称',
                               value: '云南洲途国际旅行社有限公司'
                           },
                           {
                               name: '企业地址',
                               value: '昆明市官渡区北京路锦华国际酒店14楼'
                           },
                           {
                               name: '政府评价分',
                               value: '100分'
                           },
                           {
                               name: '专业评价分',
                               value: '100分'
                           }
                ]
            }
        },

        computed: {},

        watch: {},

        methods: {
            // 考核明细接口
            getSubAssessDetail () {
                api.getAssessDetailById({ id: '335C6B06-33CA-D7E4-B539-C35B6B9BA99E', complainId: '201907141721243498431', subType: 'A1' }).then(res => {
                    if (res.ret === 0) {
                        this.complainInfo = res.data.complainInfo// 扣分详情
                        this.compDoneInfo = res.data.compDoneInfo// 投诉办结详情
                        this.infoList = [{
                                             name: '投诉单号',
                                             value: this.complainInfo.complainId
                                         },
                                         {
                                             name: '发生地区',
                                             value: this.complainInfo.complainArea
                                         },
                                         {
                                             name: '响应时间',
                                             value: this.complainInfo.respTime
                                         },
                                         {
                                             name: '处理时长',
                                             value: this.complainInfo.doneTime
                                         },
                                         {
                                             name: '一次处理时长',
                                             value: this.complainInfo.firstTime
                                         },
                                         {
                                             name: '二次处理时长',
                                             value: this.complainInfo.secondTime
                                         }
                        ]
                        this.pieList = [
                            { 'value': this.compDoneInfo.doneInNum, 'name': '已办结数量' },
                            { 'value': this.compDoneInfo.doneOutNum, 'name': '未办结数量' },
                            { 'value': this.compDoneInfo.doneNum, 'name': '总数量' }
                        ]
                    } else {
                        this.$Message.error(res.data.msg)
                    }
                });
            },
            navTo () {
                this.$router.push({
                    path: '/appraise/scoreList'
                })
            }
        },

        mounted () {
        },

        created () {}

    }
</script>
<style scoped lang="less">
  .container {
    min-height: 100vh;
    background: rgba(251, 251, 251, 1);
    padding-bottom: 24px;
  .pg-pd12 {
      padding-left: 12px;
      padding-right: 12px;

    }
        .head{
          width: 100%;
          background: #fff;
          padding: 24px 12px;
          margin-bottom: 24px;
          .title{
            height:22px;
            line-height: 22px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .text{
              font-size:20px;
              font-family:PingFangSC-Medium,PingFang SC;
              font-weight:500;
              color:rgba(51,51,51,1);
              line-height:20px;
            }
            .branch{
              height:22px;
              font-size:22px;
              font-family:DIN-Medium,DIN;
              font-weight:500;
              color:rgba(255,77,77,1);
              line-height:22px;
            }
        }
        .tip{
          margin-top:12px;
          display: flex;
          font-size:10px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(54,179,116,1);
          .con{
            border:1Px solid rgba(54,179,116,1);
            padding: 2px 4px;
            margin-right:14px;
          }
        }
        .date{
          margin-top:12px;
          font-size:12px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(153,153,153,1);
          line-height:12px;
        }
    }
.main{
      margin-top: 24px;
      .title{
        font-size:16px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1);
      }
      .content{
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
        border-radius:3px;
        margin-top: 12px;
        .ts-list{
          padding: 12px 0;
          text-align: center;
          font-size:12px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(155,155,155,1);
          line-height:17px;
          span{
            padding-right: 10px;
            background: url(../../assets/image/t-right.png) no-repeat;
            background-size: 8px 8px;
            background-position: right center;
          }
        }
        .pro-mr{
          margin-top: 24px;
          padding: 12px;
          border-top: solid 1px #eee;
        }

        }

    }
  }
</style>
